import { render, staticRenderFns } from "./ListStoreDelivery.vue?vue&type=template&id=84b8741a&scoped=true&lang=pug"
import script from "./ListStoreDelivery.vue?vue&type=script&lang=js"
export * from "./ListStoreDelivery.vue?vue&type=script&lang=js"
import style0 from "./ListStoreDelivery.vue?vue&type=style&index=0&id=84b8741a&prod&lang=scss&scoped=true"
import style1 from "./ListStoreDelivery.vue?vue&type=style&index=1&id=84b8741a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b8741a",
  null
  
)

export default component.exports